<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>


<div class="p-fluid p-2">
    <div>
        <h2 class="uppercase">Definición de valor en fletes</h2>
    </div>
    <!--Diseño Selección de ciudad-->
    <section>
        <div class="w-full flex flex-row">
            <div class="flex flex-column flex-auto p-2">
                <label for="">Seleccione el Departamento</label>
                <p-dropdown [options]="listDptos" [(ngModel)]="selectedDpto" optionLabel="nombreDepartamento"
                    class="w-full" placeholder="Selección de departamento" (onChange)="getCities()" />
            </div>
            <div class="flex flex-column flex-auto p-2">
                <label for="">Seleccione la Ciudad</label>
                <p-dropdown [options]="lsCities" [(ngModel)]="selectedCity" optionLabel="nombreCiudad" class="w-full"
                    placeholder="Selección de ciudad" (onChange)="getRangos()" />
            </div>
        </div>
    </section>
    <!--Recorrido y creación de rangos-->
    <section *ngIf="!!lsRangos">
        <h5 class="uppercase">Rangos creados</h5>
        <div class="w-full flex flex-wrap mt-2" *ngFor="let item of lsRangos">
            <div class="flex-auto p-1">
                <label for="">{{item.descripcion}} - Costo <span class="text-xs">(incluye impuesto)</span></label>
                <p-inputNumber inputId="integeronly" [(ngModel)]="item.costo" autocomplete="off" />
            </div>
            <div class="flex-auto p-1">
                <label for="">{{item.descripcion}} - Valor flete <span class="text-xs">(incluye impuesto) <span class="text-red-700">*</span></span></label>
                <p-inputNumber inputId="integeronly" [(ngModel)]="item.valor"  autocomplete="off"  />
            </div>
            <div class="flex-auto p-1">
                <label for="">{{item.descripcion}} - Pedido Mínimo <span class="text-xs">(incluye impuesto) <span class="text-red-700">*</span></span></label>
                <p-inputNumber inputId="integeronly" [(ngModel)]="item.pedidoMinimo"  autocomplete="off"  />
            </div>
            <div class="w-1 p-1 flex flex-column-reverse">
                <button pButton class="p-button p-button-success" icon="pi pi-check-circle"
                    (click)="setFlete(item)"></button>
            </div>

            <div class="w-full"><span [innerHTML]="item.message"></span></div>
        </div>
    </section>
</div>
<p-toast></p-toast>